import {Uszkodzenie} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StrategiaComponent} from './strategia.component';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';

@Component({
  templateUrl: './strategia-wartosc.component.html'
})
export class StrategiaWartoscComponent implements StrategiaComponent {

  language = window.navigator.language

  @Input()
  slownikUszkodzen!: SlownikUszkodzen;

  @Input()
  uszkodzenie!: Uszkodzenie<any>;

  @Output()
  public usunUszkodzenieClick = new EventEmitter<{identyfikatorUszkodzenia: string}>()

  usunUszkodzenie(event: {identyfikatorUszkodzenia: string}): void {
    this.usunUszkodzenieClick.emit(event)
  }
}
